var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 11.9703C15.8898 11.4319 14.4105 10.6461 13.6928 10.3294C12.7582 9.91749 12.6813 9.88384 11.9466 10.3614C11.4566 10.6801 11.1309 10.9648 10.5574 10.8577C9.9839 10.7507 8.73772 10.1473 7.64654 9.19565C6.55536 8.24396 5.82572 7.12199 5.70303 6.62191C5.58033 6.12184 5.91111 5.84017 6.27189 5.41043C6.78036 4.80468 6.7419 4.70373 6.30727 3.88597C5.96842 3.24994 5.04416 1.96779 4.42646 1.43608C3.76567 0.864997 3.76567 0.965954 3.33989 1.12075C2.99326 1.24836 2.66071 1.40347 2.34641 1.58415C1.73101 1.94187 1.38946 2.23902 1.15061 2.68559C0.911756 3.13216 0.804446 4.17909 2.03794 6.13967C3.27143 8.10026 4.13683 9.10277 5.92803 10.6656C7.71923 12.2284 9.09657 13.0687 11.1101 14.0567C13.6009 15.2773 14.5563 15.0394 15.0683 14.8307C15.5802 14.6221 15.9214 14.326 16.331 13.7875C16.538 13.513 16.7157 13.2223 16.8618 12.9193C17.0391 12.5481 17.1545 12.5481 16.5006 11.9703Z",
    stroke: "#C4E332",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7fcf374bf715b40f05f78b0e078f23a0.svg";
export { ForwardRef as ReactComponent };